import { marked } from 'marked'

function isPlainTextLine(line: string): boolean {
  const trimmed = line.trim()
  if (!trimmed) return false
  return !(
    /^#{1,6}\s/.test(trimmed) ||
    /^([-+*]|\d+[.)])\s+/.test(trimmed) ||
    /^>/.test(trimmed) ||
    /^---+$/.test(trimmed) ||
    trimmed.includes('|')
  )
}

function expandPlainLineBreaks(text: string): string {
  const lines = text.replace(/\r\n?/g, '\n').split('\n')
  return lines
    .flatMap((line, index) => {
      const next = lines[index + 1]
      if (next !== undefined && isPlainTextLine(line) && isPlainTextLine(next)) {
        return [line, '']
      }
      return [line]
    })
    .join('\n')
}

/**
 * Convert the model's Markdown to HTML for Word's `insertHtml`, so proposals
 * carry real formatting (headings, bold, lists, tables) instead of plain text.
 * Plain text without Markdown syntax passes through as simple paragraphs.
 */
export function markdownToHtml(text: string): string {
  return marked.parse(expandPlainLineBreaks(text), { async: false, gfm: true, breaks: false }) as string
}

/**
 * The text itself when the Markdown carries no formatting at all (single line,
 * no block or inline markup), else undefined. Lets replace handlers use Word's
 * `insertText` — which inherits the surrounding character formatting (bold,
 * font, color) — instead of `insertHtml`, which resets the span to the HTML's
 * own formatting. Conservative: any markup-significant character falls back to
 * the HTML path.
 */
export function inlinePlainText(text: string): string | undefined {
  const value = text.trim()
  if (!value || value.includes('\n')) return undefined
  if (!isPlainTextLine(value)) return undefined
  if (/[*_`~[\]<>\\]/.test(value)) return undefined
  // Preserve intentional boundary spaces in legal wording replacements. The
  // trimmed copy above is used only to classify the payload as plain text.
  return text
}
